import store from '@state/store'

let axiosBase = require('axios')

axiosBase.interceptors.response.use(function (response) {

    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
}, function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
});

export const axios = {

    getAppCredentials() {
        return store.state.appAuth.appSession
            ? `key ${store.state.appAuth.appSession.key}` : ''
    },

    changeValue(obj) {
        if (process.env.VUE_APP_SECURE_SCHEMA_REQUEST === 'true'){

            if (typeof obj === 'object') {
            // iterating over the object using for..in
                for (let keys in obj) {
                //checking if the current value is an object itself
                    if (typeof obj[keys] === 'object') {
                        // if so then again calling the same function
                        this.changeValue(obj[keys])
                    } else if (typeof obj[keys] === 'string') {
                        // else getting the value and replacing single { with {{ and so on
                        let keyValue = obj[keys].replace('http://', 'https://');    
                        obj[keys] = keyValue;
                    }
                }
            } else if (typeof obj === 'string') {
                return obj.replace('http://', 'https://');
            }
        }
        return obj;
    },

    defaultOptions(options) {
        let extraOptions = {
            headers: {
                'Authorization': store.state.auth.currentSession
                    ? `key ${store.state.auth.currentSession.key}` : '',
                'Accept-Language': store.state.language.language
                    ? store.state.language.language : 'en'
            },
        }
        // appRequest makes the request auto-authenticable (no-user login required)
        // axios uses in-app-auth built-in instead
        if ('appRequest' in options && options.appRequest) {
            delete options["appRequest"];
            extraOptions.headers['Authorization'] = this.getAppCredentials()
        }
        if ('headers' in options && options.headers){
            extraOptions.headers = {
                ...extraOptions.headers,
                ...options.headers
            }
            delete options.headers            
        }
        return {
            ...extraOptions,
            ...options
        }
    },
    get(url, options = {}) { 
        // console.log("get url:", url, this.changeValue(url), options)
        return axiosBase.get(this.changeValue(url), this.defaultOptions(options)) 
    },
    post(url, data, options = {}) { 
        // console.log("post url:", url, this.changeValue(url), options)
        return axiosBase.post(this.changeValue(url), this.changeValue(data), this.defaultOptions(options)) 
    },
    put(url, data, options = {}) { 
        // console.log("put url:", url, this.changeValue(url), options)
        return axiosBase.put(this.changeValue(url), this.changeValue(data), this.defaultOptions(options)) 
    },
    delete(url, options = {}) { 
        // console.log("delete url:", url, this.changeValue(url), options)
        return axiosBase.delete(this.changeValue(url), this.defaultOptions(options)) 
    }
}

export default axios